<template>
  <div class="article-details">
    <el-main>
      <h3 class="title">{{ articleRes.title }}</h3>
      <div class="other_info">
        <div class="time">
          發佈時間：{{ $dayjs(articleRes.publish_time).format("YYYY-MM-DD") }}
        </div>
        <!-- <div class="collect">
          <i
            v-if="!favouriteState"
            class="el-icon-star-off little_hand"
            @click="fncollection"
          ></i>
          <i
            v-else
            class="el-icon-star-on little_hand"
            @click="fncollection"
          ></i>
        </div> -->
      </div>
      <div v-if="articleRes.video_url">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>
      <div v-html="articleRes.content" class="con"></div>
      <div class="show_more" v-if="isShowMore">
        <div class="artlineContent"></div>
        <div class="tongjiNumber little_hand" @click="isShowFeeList = true">
          <span class="box_titlecontent cost-uibtn">訂閱後繼續閱讀</span>
          <div class="triangle"></div>
        </div>
        <div class="loginContent" v-if="!validToken">
          <span
            class="color40 loginColor openLoginWindowMain little_hand"
            @click="$store.state.isDialogVisible = true"
            >登錄</span
          >
          &nbsp;後獲取已訂閱的閱讀權限
        </div>
        <div class="subBtnContent">
          <div class="subLeftContent">
            深圳台協收費文章<br />請購買後查看全文
          </div>
          <span
            class="subRightContent cost-uibtn little_hand"
            @click="isShowFeeList = true"
            >訂閱</span
          >
        </div>
      </div>
      <!-- <div class="show_more little_hand" v-if="isShowMore">
    　　<span class="show_more_btn" @click="isShowFeeList=true">￥{{articleRes.article_price?articleRes.article_price:0}} 解鎖文章</span>
    </div> -->
      <el-dialog
        :visible.sync="isShowFeeList"
        title="選擇付費方式"
        width="450px"
        center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <i class="el-icon-close" @click="isShowFeeList = false"></i>
        <div class="fee_list">
          <div
            class="fee_list_item"
            v-for="item in feeList"
            :key="item.name"
            @click="fnToPay(item.equitypackage_id, item.price)"
          >
            <span class="name">{{ item.name }}</span>
            <span class="price">￥ {{ item.price }}</span>
            <span class="desc">{{ item.description }}</span>
            <!-- <span :class="$style.duration">{{item.duration}}</span> -->
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="isShowQcode"
        title="打開微信掃一掃付款"
        width="450px"
        center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <i class="el-icon-close" @click="isShowQcode = false"></i>
        <img :src="payCode" width="200px" height="200px" />
      </el-dialog>
      <div class="thumb little_hand" @click="fnClickLike">
        <img v-if="isliked == 0" src="../assets/imgs/like.svg" />
        <img v-else src="../assets/imgs/like-active.svg" />
        <span class="thumb-num">{{ likes }}</span>
      </div>
      <div class="share_container">
        <span class="tag">分享：</span>
        <div class="wx little_hand">
          <el-popover
            placement="top"
            width="100"
            trigger="hover"
            popper-class="wx_popper"
          >
            <el-image
              style="width: 100px; height: 100px"
              :src="qrCodeImg"
              fit="cover"
            ></el-image>
            <img
              slot="reference"
              src="https://www.sztmas.cn/assets/images/weixin1.png"
              alt=""
            />
          </el-popover>
        </div>
        <div class="wb little_hand" @click="shareToWb">
          <img src="https://www.sztmas.cn/assets/images/weibo.png" alt="" />
        </div>
      </div>
      <div class="relate_article">
        <!-- <ul>
        <li>上一篇：台湾复兴航空突然停航！到底发生了什么？</li>
        <li>下一篇：台湾复兴航空突然停航！到底发生了什么？</li>
      </ul> -->
      </div>
      <div class="fix_btn">
        <div class="btn_xl" slot="reference" @click="fnClickLike">
          <img v-if="isliked == 0" src="../assets/imgs/like.svg" />
          <img v-else src="../assets/imgs/like-active.svg" />
        </div>
        <div slot="reference" @click="fncollection">
          <em v-if="!favouriteState" class="el-icon-star-off"></em>
          <em v-else class="el-icon-star-on"></em>
        </div>
        <el-popover
          placement="left"
          width="100"
          trigger="hover"
          popper-class="wx_popper"
        >
          <img :src="qrCodeImg" style="width: 100px; height: 100px" />
          <div class="btn_wx" slot="reference"><em></em></div>
        </el-popover>
        <div class="btn_xl" slot="reference"><em></em></div>
        <div class="btn_top" @click="backTop"><em></em></div>
      </div>
    </el-main>
  </div>
</template>
<script>
import { mapState } from "vuex";
var timer;

export default {
  data() {
    return {
      isShowMore: true,
      isShowFeeList: false,
      isShowQcode: false,
      isPaying: false, //是否正在支付
      payStartTime: "",
      feeList: [
        {
          name: "單篇付費",
          price: 0,
          description: "單篇",
          equitypackage_id: 0,
        },
      ],
      code_url: "",
      articleRes: {},
      favouriteState: 0, //收藏状态
      isliked: 0, //点赞状态
      likes: 0, //點贊數量
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  computed: {
    ...mapState(["user_id", "validToken"]),
    qrCodeImg() {
      return (
        "https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=https://api2.ts960.com/wechatxh/html/article.html?contentid=" +
        this.$route.params.id
      );
    },
    payCode() {
      return `https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=${this.code_url}`;
    },
  },
  watch: {
    user_id(val) {
      this.getUserFavouriteState();
      this.getUserLikeState();
    },
  },
  methods: {
    async getArticleDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/article/${this.$route.params.id}`
      );
      console.log(res);
      // if (res.code !== "200") return this.$message.error(res.msg);
      this.articleRes = res.data;
      this.likes = this.articleRes.likes;
      this.feeList[0].price = res.data.article_price
        ? res.data.article_price
        : 0;

      let newdate = new Date();
      let diff = (newdate - this.payStartTime) / 1000 / 60;
      console.log(diff);
      if (res.code == 51000) {
        if (diff > 5 && this.isPaying) {
          this.$message.error("支付失敗");
          clearInterval(timer);
          this.isShowQcode = false;
          this.isShowFeeList = false;
        }
        this.isShowMore = true;
        this.articleRes.content = res.data.content.substring(0, 500);
      } else {
        if (this.isPaying) {
          this.$message.success("支付成功");
          clearInterval(timer);
        }
        this.isShowMore = false;
        this.isShowQcode = false;
        this.isShowFeeList = false;
        this.articleRes.content = res.data.content;
      }

      setTimeout(() => {
        this.$zhTran();
      }, 300);
      if (!this.articleRes.video_url) return;
      this.playerOptions.sources[0].src = this.articleRes.video_url;
      let main_image = JSON.parse(this.articleRes.main_image);
      this.playerOptions.poster = main_image.map((img) =>
        !/^http/.test(img) ? this.$imgUrl + img : img
      );
    },
    //获取收藏状态
    async getUserFavouriteState() {
      const { data: res } = await this.$http.get(
        `/api/v2/article/getFavouriteState/${this.user_id}/${this.$route.params.id}`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      this.favouriteState = res.data.state;
    },
    //收藏
    async fncollection() {
      console.log("=====", this.validToken);
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        let favouriteState = this.favouriteState ? 0 : 1;
        const { data: res } = await this.$http.get(
          `api/v2/article/favourite/${this.user_id}/${this.$route.params.id}/${favouriteState}`
        );
        if (res.code !== "200") return this.$message.error(res.msg);
        let msg = !this.favouriteState ? "收藏成功" : "取消收藏";
        this.$message.success(msg);
        this.favouriteState = favouriteState;
      }
    },
    //获取点赞状态
    async getUserLikeState() {
      const { data: res } = await this.$http.get(
        `/api/v2/article/getLikeState/${this.user_id}/${this.$route.params.id}`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      this.isliked = res.data.likestate;
    },
    //点赞
    async fnClickLike() {
      // if (!this.validToken) {
      //   this.$store.state.isDialogVisible = true;
      // } else {
      // let isliked = this.isliked == 0 ? 1 : 0;
      const { data: res } = await this.$http.get(
        `api/v2/article/likeByPc/${this.$route.params.id}`
      );
      if (res.code !== "200") return this.$message.error(res.msg);
      // let msg = this.isliked == 0 ? "點贊成功" : "取消點贊";
      this.$message.success("點贊成功");
      this.isliked = 1;
      this.likes = res.data;
      // }
    },
    // 获取文章包月费用
    async getArticleEquitypackage() {
      const { data: res } = await this.$http.get(
        `api/v2/article/articleEquitypackage`
      );
      console.log(res);
      // if (res.code !== "200") return this.$message.error(res.msg);
      res.data.map((item) => {
        this.feeList.push({
          name: item.name,
          price: item.price,
          duration: item.duration,
          description: item.description,
          equitypackage_id: item.equitypackage_id,
        });
      });
    },
    async fnToPay(equitypackage_id, money) {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        let cunpanUrl = "";
        if (equitypackage_id == 0) {
          cunpanUrl = `/api/v2/order/resourcesPayByH5/${
            this.$route.params.id
          }/12/${
            this.user_id
          }/${money}/${"Tobfusion"}?ipAddress=${localStorage.getItem("Ip")}`;
        } else {
          cunpanUrl = `/api/v2/order/resourcesPayByH5/${equitypackage_id}/13/${
            this.user_id
          }/${money}/${"Tobfusion"}?ipAddress=${localStorage.getItem("Ip")}`;
        }
        const { data: res } = await this.$http.post(cunpanUrl);
        console.log(res.data.code_url);
        this.code_url = res.data.code_url;
        this.isShowQcode = true;
        this.isShowFeeList = false;
        // alert(this.mweb_url)
        // window.open(this.mweb_url, "newwindow");
        this.isPaying = true;
        this.payStartTime = new Date();
        timer = setInterval(() => {
          this.getArticleDetails();
        }, 5000);
      }
    },
    shareToWb() {
      let title = this.articleRes.title;
      let url =
        "https://api2.ts960.com/wechatxh/html/article.html?contentid=" +
        this.$route.params.id;
      let main_image = JSON.parse(this.articleRes.main_image);
      let picurl = main_image.map((img) =>
        !/^http/.test(img) ? this.$imgUrl + img : img
      );
      console.log(picurl);
      var sharesinastring =
        "http://v.t.sina.com.cn/share/share.php?title=" +
        title +
        "&url=" +
        url +
        "&content=utf-8&sourceUrl=" +
        url +
        "&pic=" +
        picurl[0];
      window.open(
        sharesinastring,
        "newwindow",
        "height=400,width=400,top=100,left=100"
      );
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      let that = this;
      // let timer = setInterval(() => {
      //   let ispeed = Math.floor(-that.scrollTop / 5);
      //   document.documentElement.scrollTop = document.body.scrollTop =
      //     that.scrollTop + ispeed;
      //   if (that.scrollTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 16);
    },
  },
  created() {
    this.getArticleDetails();
    this.getArticleEquitypackage();
  },
  mounted() {
    if (this.user_id) {
      this.getUserFavouriteState();
      this.getUserLikeState();
    }
  },
};
</script>
<style>
/* 文章内嵌的视频高度 */
iframe {
  min-height: 506px !important;
}
.con {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #222222;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: 400;
}
.con img {
  max-width: 100% !important;
  display: block;
  margin: 20px 0;
  border-radius: 4px;
}
@media screen and (max-width: 768px) {
  .con img {
    margin: 10px 0 !important;
  }
}
</style>
<style lang="less" scoped>
.article-details {
  background: #f2f2f2;
  padding: 50px 0;
}
.el-main {
  width: 1000px;
  padding: 36px 40px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-size: 36px;
    color: #222222;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .other_info {
    position: relative;
    margin-bottom: 40px;
    .time {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #888888;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
    }
    .collect {
      position: absolute;
      top: 50%;
      right: 2px;
      transform: translateY(-50%);
      i {
        font-size: 30px;
        margin-right: 18px;
      }
      .el-icon-star-on {
        color: #3135cb;
      }
      .el-button {
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
        background: #3135cb;
        padding: 2px 14px;
        border-radius: 28px;
        border: none;
      }
    }
  }
  .fix_btn {
    position: fixed;
    top: 50%;
    right: 27px;
    z-index: 99;

    div {
      cursor: pointer;
      width: 60px;
      height: 60px;
      border-radius: 8px;
      margin-bottom: 5px;
      background-color: #fff;
      background-size: contain;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    div:hover {
      background: rgba(0, 0, 0, 0.04);
    }
    em {
      width: 30px;
      height: 30px;
      display: inline-block;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      font-size: 30px;
    }
    .btn_wx em {
      background-image: url("../assets/images/weixin1.png");
    }
    .btn_xl em {
      background-image: url("../assets/images/weibo.png");
    }
    .btn_top em {
      background-image: url("../assets/imgs/arrow.svg");
      transform: rotate(-90deg);
    }
    .btn_xl img {
      width: 30px;
      height: 30px;
    }
  }
  .show_more {
    width: 100%;
    text-align: center;
    padding: 40px 0;
    // margin-top: -74px;
    position: relative;
    .artlineContent {
      // background: url(../assets/images/lineContent.png) repeat-x;
      height: 44px;
      z-index: 2;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .tongjiNumber {
      font-size: 18px;
      color: #282828;
      text-align: center;
      .triangle {
        border-bottom: 4px solid transparent;
        border-top: 4px solid #f12e2b;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        width: 0;
        height: 0;
        overflow: hidden;
        margin: 5px auto 28px;
      }
    }
    .loginContent {
      font-size: 18px;
      margin-bottom: 30px;
      .loginColor {
        color: #2686d5;
        border-bottom: 1px solid #2686d5;
        padding-bottom: 2px;
        font-size: 18px;
      }
    }
    .subBtnContent {
      margin-bottom: 25px;
      font-size: 18px;
      color: #b0977f;
      text-align: right;
      width: 350px;
      margin: 0 auto 25px;
      height: 44px;
      .subLeftContent {
        border-right: 1px solid #f8ad18;
        padding-right: 18px;
        margin-right: 18px;
        float: left;
      }
      .subRightContent {
        float: left;
        width: 150px;
        border-radius: 40px;
        line-height: 44px;
        background: #f8ad18;
        font-size: 20px;
        color: #fff;
        position: relative;
        text-align: center;
      }
    }
  }
  .show_more .show_more_btn {
    text-decoration: none;
    color: #333;
    padding: 10px 20px;
    border: 1px solid #67a2ea;
    border-radius: 40px;
    font-size: 18px;
  }
  .thumb {
    border: 1px solid #3135cb;
    border-radius: 50px;
    margin: auto;
    margin-top: 40px;
    width: 80px;
    height: 80px;
    background: #20317f;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      filter: drop-shadow(#fff 80px 0);
      transform: translateX(-80px);
      width: 30px;
      height: 30px;
      margin-bottom: 2px;
    }
    .thumb-num {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
  .share_container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 15px;
    .tag {
      font-size: 16px;
      font-weight: 300;
      color: #424242;
      line-height: 42px;
      margin-right: 15px;
      padding: 6px 0;
    }
    .wx {
      span {
        display: flex;
      }
    }
    div {
      width: 45px;
      height: 45px;
      border-radius: 45px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      padding: 10px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-right: 10px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  hr {
    opacity: 0.06;
  }
  .relate_article {
    ul li {
      font-size: 16px;
      font-weight: 300;
      color: rgba(66, 66, 66, 1);
      line-height: 30px;
      cursor: pointer;
    }
  }
}
/deep/.el-dialog {
  border-radius: 22px;
  margin-top: 30vh !important;
  .el-dialog__title {
    line-height: 60px;
    font-size: 20px;
    color: #303133;
    font-weight: bold;
  }
  i {
    position: absolute;
    right: 25px;
    top: 25px;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
  }
  .fee_list {
    display: flex;
    align-content: center;
    justify-content: space-around;
    .fee_list_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 20px;
      border-right: 1px dashed #ccc;
      cursor: pointer;
      .price {
        font-size: 18px;
        color: #f12e2b;
      }
      .name {
        font-size: 18px;
      }
      .desc {
        font-size: 16px;
        color: #ccc;
      }
      .duration {
        font-size: 16px;
      }
    }
    .fee_list_item:last-child {
      border: none;
    }
  }
}
.video-js .vjs-icon-placeholder {
  width: 100%;
  height: 100%;
  display: block;
}
@media screen and (max-width: 768px) {
  .article-details {
    padding: 0;
  }
  .el-main {
    width: 100%;
    padding: 0 20px;
    .title {
      font-size: 20px;
      margin-bottom: 10px;
      padding-top: 10px;
    }
    .other_info {
      margin-bottom: 20px;
    }
    .con {
      line-height: 30px;
      font-size: 16px;
    }
    .fix_btn {
      right: 15px;
      div {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        margin-bottom: 5px;
      }
      em {
        width: 20px;
        height: 20px;
        font-size: 20px;
      }
      .btn_xl img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
